import React, { useEffect, useState } from 'react';
import axiosInstance from 'Utils/Interceptor';
import { useFormik } from 'formik';
import StarRating from 'Assets/SVG/startrating.svg';
import StarRatingFill from 'Assets/SVG/starratingfill.svg';

import CustomModal from 'Components/Modal/CustomModal';
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';

const initialValues = {
  first_name: '',
  last_name: '',
  email: '',
  mobileno: ''
};

function RatingModal({
  handleCloseModal,
  showModal,
  bookingId,
  setOpenRatingModal
}) {
  const [starCount, setStartCount] = useState(-1);
  const [ratingList, setRatingList] = useState([]);
  const [selectedRating, setSelectedRating] = useState();
  const [selectedQuestion, setSelectedQuestion] = useState();
  const navigation = useNavigate();
  const handleSelectedQuestion = (id) => setSelectedQuestion(id);

  const fetchContent = async () => {
    try {
      const response = await axiosInstance.get(`/api/user/feedback-reason`);
      setRatingList(response?.data?.data);
    } catch (error) {}
  };

  const formik = useFormik({
    initialValues: initialValues,
    validateOnBlur: false,
    validateOnChange: true,
    onSubmit: async (formikvalues, { setSubmitting }) => {
      try {
        const { data } = await axiosInstance.post('/api/user/bookingfeedback', {
          rating: starCount,
          feedbackreason: selectedQuestion?.title,
          type: 'Booking Feedback',
          ...(bookingId && { booking_id: bookingId })
        });

        if (data?.status) {
          toast.success(data?.message, {});
          setOpenRatingModal && setOpenRatingModal(false);
          handleCloseModal && handleCloseModal();
        } else {
          toast.error(data?.message, {});
        }
      } catch (errors) {
        toast.error(errors?.data?.error?.message, {});
      }
      navigation('/my-booking');
    }
  });

  useEffect(() => {
    fetchContent();
    return () => {
      setStartCount(-1);
      setRatingList([]);
      setSelectedQuestion();
      setSelectedRating();
      formik.resetForm();
    };
  }, [showModal]);

  const handleStarRating = (rating, list) => {
    setStartCount(rating);
    setSelectedRating(list);
    handleSelectedQuestion();
  };
  return (
    <CustomModal
      show={showModal}
      onClose={handleCloseModal}
      size="full"
    >
      <div className="">
        <div className="container h-100">
          <div className="row h-100">
            <div className="col-12">
              <div className="rating-wrapper">
                <div className="heading">
                  <h2>
                    Your Feedback <br /> is important for Us!
                  </h2>
                  <p>
                    Please share your feedback on the latest booking Journey
                  </p>
                </div>

                <div className="star-wrapper">
                  {ratingList?.map((list) => (
                    <img
                      src={
                        starCount >= list?.star_rate
                          ? StarRatingFill
                          : StarRating
                      }
                      key={list?.star_rate}
                      onClick={() => handleStarRating(list?.star_rate, list)}
                      alt=""
                    />
                  ))}
                </div>

                <div className="question-wrapper">
                  <p>{selectedRating?.review_title}</p>

                  <div>
                    {selectedRating?.reviewOptions.map((e) => (
                      <button
                        className={
                          selectedQuestion?.id === e.id && 'selected-question'
                        }
                        onClick={() => handleSelectedQuestion(e)}
                      >
                        {e.title}
                      </button>
                    ))}
                  </div>
                </div>

                <div class="form-group submit-action">
                  <button
                    disabled={!selectedQuestion}
                    type="submit"
                    onClick={formik.handleSubmit}
                    class="btn btn-md"
                  >
                    <span>Submit</span>
                  </button>
                  <button
                    onClick={() => {
                      setOpenRatingModal && setOpenRatingModal(false);
                      navigation('/my-booking');
                    }}
                    className="btn btn-md btn-stroke"
                  >
                    <span>Cancel</span>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </CustomModal>
  );
}

export default RatingModal;
